import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import validation from "./modules/validation";
import files from "./modules/files";
import dictionaries from "./modules/dictionaries";
import wall from "@/store/modules/wall";
import user from "@/store/modules/user";
import tasks from "@/store/modules/tasks";
import application from "@/store/modules/application";
import notifications from "@/store/modules/notifications";
import groups from "@/store/modules/groups";
import searcher from "@/store/modules/searcher";
import abuses from "@/store/modules/abuses";
import chat from "@/store/modules/chat";


Vue.use(Vuex);

export default new Vuex.Store({
	state: {},
	mutations: {},
	actions: {},
	modules: {
		auth,
		validation,
		files,
		dictionaries,
		wall,
		user,
		tasks,
		application,
		notifications,
		groups,
		searcher,
		abuses,
		chat
	},
});
